module.exports = __webpack_public_path__ + "static/media/menu2.c048ea08.svg";